import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

// Translations are split by domain (see client/public/locales/{lng}/*.json) instead of a single
// flat file. defaultNS + fallbackNS let every existing t('key') call keep working unchanged: if a
// key isn't found in "common" it's looked up in the rest of the namespaces in this same order.
const NAMESPACES = [
    'common',
    'users',
    'stores',
    'nodes',
    'inventories',
    'catalogues',
    'searchLists',
    'statistics',
    'dashboard',
    'alarms',
    'sip',
    'imageSets',
    'floorPlans',
    'auth',
    'libraryAmenities',
    'notifications'
]

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        ns: NAMESPACES,
        defaultNS: 'common',
        fallbackNS: NAMESPACES,
        interpolation: {
            escapeValue: false
        },
        load: 'languageOnly'
    })

export default i18n
